type ContainedImageRectInput = {
  sourceWidth: number;
  sourceHeight: number;
  frameX: number;
  frameY: number;
  frameWidth: number;
  frameHeight: number;
};

export const getRewardLeadCopy = (badgeName?: string, fallbackDescription?: string) => {
  if (badgeName === '慧眼识人' || badgeName === '组队勋章') {
    return '你能抓住人物特点来铺设探险之旅';
  }

  if (badgeName === '精装上阵' || badgeName === '启程勋章' || badgeName === '生存勋章') {
    return '你能抓住情境特征选择合适的装备';
  }

  if (badgeName === '巧设险局' || badgeName === '勇气勋章') {
    return '遇到险情时，你能分析情况并选择合适的办法';
  }

  if (badgeName === '逃生高手') {
    return '你能展开丰富而合理的想象，把困境和求生方法写具体';
  }

  return fallbackDescription ?? '';
};

export const getTeamMemberLabel = (username?: string) => {
  const trimmed = username?.trim();
  return trimmed ? trimmed : '我';
};

export const splitCanvasLabelLines = (label: string, maxCharsPerLine = 6, maxLines = 2) => {
  const chars = Array.from(label.trim());
  if (chars.length === 0) {
    return [];
  }

  const lines: string[] = [];
  for (let index = 0; index < chars.length && lines.length < maxLines; index += maxCharsPerLine) {
    const remaining = chars.length - index;
    if (lines.length === maxLines - 1) {
      lines.push(chars.slice(index, index + remaining).join(''));
      break;
    }
    lines.push(chars.slice(index, index + maxCharsPerLine).join(''));
  }

  return lines;
};

export const getContainedImageRect = ({
  sourceWidth,
  sourceHeight,
  frameX,
  frameY,
  frameWidth,
  frameHeight,
}: ContainedImageRectInput) => {
  if (sourceWidth <= 0 || sourceHeight <= 0) {
    return {
      x: frameX,
      y: frameY,
      width: frameWidth,
      height: frameHeight,
    };
  }

  const scale = Math.min(frameWidth / sourceWidth, frameHeight / sourceHeight);
  const width = sourceWidth * scale;
  const height = sourceHeight * scale;
  const x = frameX + (frameWidth - width) / 2;
  const y = frameY + (frameHeight - height) / 2;

  return { x, y, width, height };
};
